module.exports = __webpack_public_path__ + "assets/b86.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b86.png
// module id = 678
// module chunks = 0